import { gql } from '@apollo/client';

const createMcpKey = gql`
  mutation CreateMcpKey($input: CreateMcpKeyInput!) {
    createMcpKey(input: $input) {
      id
      key
      key_prefix
      label
      scopes
      expires_at
      createdAt
    }
  }
`;

export default createMcpKey;
